import type { ReactNode } from 'react';
import styles from './FormCard.module.css';

export interface FormCardProps {
	icon: ReactNode;
	title: string;
	children?: ReactNode;
	className?: string;
}

export const FormCard = ({ icon, title, children, className }: FormCardProps) => (
	<div className={`${styles.card} ${className ?? ''}`}>
		<div className={styles.header}>
			<div className={styles.iconWrapper}>{icon}</div>
			<h2 className={styles.title}>{title}</h2>
		</div>
		<div className={styles.divider} />
		{children && <div className={styles.content}>{children}</div>}
	</div>
);
